import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import LeadForm from "../components/LeadForm";

export default function Contact() {
    return (
        <div data-testid="page-contact" className="bg-white">
            {/* HERO */}
            <section className="bg-[#0A2540] text-white py-20" data-testid="contact-hero">
                <div className="max-w-7xl mx-auto px-6 lg:px-8">
                    <div className="uppercase tracking-[0.2em] text-xs font-semibold text-[#C5A059]">Contact</div>
                    <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] max-w-3xl">
                        Let's get your project <span className="text-[#C5A059]">approved.</span>
                    </h1>
                    <p className="mt-6 text-lg text-white/75 max-w-2xl leading-relaxed">
                        Send us your project details and a permit specialist will reach out within one business day.
                    </p>
                </div>
            </section>

            {/* CONTENT */}
            <section className="py-24" data-testid="contact-content">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-[1fr_1.3fr] gap-16">
                    {/* Info */}
                    <div>
                        <h2 className="text-3xl font-semibold text-[#0A2540] tracking-tight">
                            Get in touch
                        </h2>
                        <p className="mt-4 text-[#475569] leading-relaxed">
                            Call us directly or submit the form. We'll respond with a free project review and transparent quote.
                        </p>

                        <div className="mt-10 space-y-6">
                            <ContactCard
                                icon={Phone}
                                label="Phone"
                                value="951-249-3125"
                                href="tel:9512493125"
                                testId="contact-info-phone"
                            />
                            <ContactCard
                                icon={Mail}
                                label="Email"
                                value="info@ezpermitexpress.com"
                                href="mailto:info@ezpermitexpress.com"
                                testId="contact-info-email"
                            />
                            <ContactCard
                                icon={MapPin}
                                label="Service Area"
                                value="Nationwide — All 50 States"
                                testId="contact-info-area"
                            />
                            <ContactCard
                                icon={Clock}
                                label="Hours"
                                value="Mon–Fri, 8AM – 6PM PST"
                                testId="contact-info-hours"
                            />
                        </div>

                        <div className="mt-12 bg-[#F8FAFC] border border-[#E2E8F0] p-6">
                            <div className="uppercase tracking-[0.2em] text-xs font-semibold text-[#C5A059]">Response Time</div>
                            <p className="mt-2 text-[#0A2540] font-semibold">
                                Typical reply within 1 business day.
                            </p>
                            <p className="mt-1 text-sm text-[#475569]">
                                Urgent? Call us directly for same-day service.
                            </p>
                        </div>
                    </div>

                    {/* Form */}
                    <div className="bg-[#F8FAFC] border border-[#E2E8F0] p-8 md:p-10">
                        <h3 className="text-2xl font-semibold text-[#0A2540] tracking-tight">Project inquiry</h3>
                        <p className="mt-2 text-sm text-[#475569]">
                            Fields marked * are required.
                        </p>
                        <div className="mt-6">
                            <LeadForm source="contact" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

function ContactCard({ icon: Icon, label, value, href, testId }) {
    const content = (
        <div
            className="flex items-start gap-4 p-5 border border-[#E2E8F0] bg-white hover:border-[#C5A059] transition-colors"
            data-testid={testId}
        >
            <div className="w-11 h-11 flex items-center justify-center bg-[#0A2540] text-[#C5A059] flex-shrink-0">
                <Icon size={20} />
            </div>
            <div>
                <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#475569]">{label}</div>
                <div className="mt-1 text-lg font-semibold text-[#0A2540]">{value}</div>
            </div>
        </div>
    );

    if (href) return <a href={href}>{content}</a>;
    return content;
}
